import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import LabelForm from "components/LabelForm/LabelForm";
import {
    Container, Content,
    Button, Text, Wrapper
} from "./styles";
import { HelperText, Row } from "components/styles";

const FoundField = ({
    width, size,
    label, text, 
    error, errorText,
    button, helperText
}) => {
    return (
        <Wrapper>
            {label && <LabelForm text={label}/>}
            <Container className={error && "error"}>
                <Row width="unset">
                    <Content width={width} className={size}>
                        <Text title={text}>{text}</Text>
                        <Button className={error && "error"}
                            onClick={button?.onClick}>
                            {button?.text}
                        </Button>
                    </Content>
                    {helperText && <HelperText>{helperText}</HelperText>}
                </Row>
                <ErrorMessage error={error} text={errorText}/>
            </Container>
        </Wrapper>
    );
}

export default FoundField;